import ValidatorResult from "../classes/validator.results";
export default class NotEqualsValidationRule {
    name = 'notequals';
    validate(validation, rules, value, object, manager) {
        //message
        let tError = appHost.localizer?.t('system.Validation.NotEquals', [validation.displayName, manager.rules[rules.props]?.displayName]);
        //Check first Value
        if (typeof rules.props !== 'string') {
            return new ValidatorResult(false, tError);
        }
        if (value === undefined || value === null) {
            return new ValidatorResult(true);
        }
        //Get second Value
        let value2 = utils.getObjectValue(object, rules.props);
        if ((typeof value2 === 'undefined' && typeof value !== 'undefined') || value2.toString() === value.toString()) {
            return new ValidatorResult(false, tError);
        }
        return new ValidatorResult(true);
    }
}
